import { Box } from "@material-ui/core";
import * as H from "history";
import React from "react";
import { DatePickerButton, PickerType } from "halifax";
import clsx from "clsx";

import { ExperiencesSearchButton } from "../../search/components/ExperiencesSearchControl/components/SearchButton";
import "./styles.scss";
import { SEARCH_EXPERIENCES_BUTTON } from "../../search/textConstants";
import {
  MonthAndDatePicker,
  MonthAndDatePickerType,
} from "../MonthAndDatePicker";
import { useQueryParams } from "@capone/common";

export interface IMobileCalendarPickerProps {
  fromDate: Date | null;
  untilDate: Date | null;
  setFromDate: (from: Date | null) => void;
  setUntilDate: (until: Date | null) => void;
  focusedMonthIndex?: number;
  handleSearch: (history: H.History) => void;
  pickerType?: PickerType;
  unavailableDates?: Date[];
  pricePerDay?: { [date: string]: string };
  buttonLabel?: string;
}

export const MobileCalendarPicker = (props: IMobileCalendarPickerProps) => {
  const {
    fromDate,
    untilDate,
    setFromDate,
    setUntilDate,
    focusedMonthIndex,
    handleSearch,
    pickerType,
    unavailableDates,
    pricePerDay,
    buttonLabel,
  } = props;

  const params = useQueryParams();
  const isTravelApp = params.isTravelApp === "true";

  const [from, setFrom] = React.useState<Date | null>(null);
  const [until, setUntil] = React.useState<Date | null>(null);

  React.useEffect(() => {
    setFrom(fromDate);
  }, [fromDate]);

  React.useEffect(() => {
    setUntil(untilDate);
  }, [untilDate]);

  const handleSearchClick = (history: H.History) => {
    handleSearch(history);
  };

  return (
    <Box className="experiences-mobile-calendar-picker-root">
      <DatePickerButton
        startDate={from}
        startLabel="When?"
        endDate={until}
        endLabel=""
        classes={[]}
        variant="combinedDates"
        dateFormat="ddd, MMM D"
        hideEndDate
        hideSeparator
      />
      <MonthAndDatePicker
        className="b2b"
        pickerType={pickerType}
        viewType={MonthAndDatePickerType.Column}
        focusedMonthIndex={focusedMonthIndex}
        setStartDate={setFromDate}
        setEndDate={setUntilDate}
        startDate={from}
        endDate={until}
        unavailableDates={unavailableDates}
        pricePerDay={pricePerDay}
      />
      {from && !isTravelApp && (
        <Box className="mobile-experiences-search-button-container">
          <ExperiencesSearchButton
            className={clsx(
              "mobile-experience-calendar-picker-search-button",
              "b2b"
            )}
            message={buttonLabel || SEARCH_EXPERIENCES_BUTTON}
            onClick={(history) => {
              handleSearchClick(history);
            }}
          />{" "}
        </Box>
      )}
    </Box>
  );
};
